import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { Category } from "../models/category.model";

const BASE_URL = process.env.REACT_APP_API_URL || "http://localhost:5001/api/";

// console.log(BASE_URL)

export const CategoryApi = createApi({
  reducerPath: "CategoryApi",
  baseQuery: fetchBaseQuery({ baseUrl: BASE_URL }),
  tagTypes: ["Category"],
  endpoints: (builder) => ({
    categories: builder.query<Category[], any>({
      query: () => "/category",
      providesTags: ["Category"],
    }),
    categoriesExport: builder.query<Category[], any>({
      query: ({ aamarId }) => `/category/export/${aamarId}`,
      providesTags: ["Category"],
    }),
    category: builder.query<Category, string>({
      query: (_id) => `/category/${_id}`,
      providesTags: ["Category"],
    }),
    masterCategory: builder.query<Category[], any>({
      query: ({ aamarId }) => `/category/master/${aamarId}`,
      providesTags: ["Category"],
    }),
    masterCategoryList: builder.query<Category[], any>({
      query: ({ aamarId }) => `/category/list/${aamarId}`,
      providesTags: ["Category"],
    }),
    categoryList: builder.query<Category[], any>({
      query: ({ aamarId }) => `/category/scList/${aamarId}`,
      providesTags: ["Category"],
    }),
    categoryImportList: builder.query<Category[], any>({
      query: (aamarId) => `/category/importlist/${aamarId}`,
      providesTags: ["Category"],
    }),
    AllCategory: builder.query<Category, any>({
      query: ({ aamarId, q }) => `/category/all/${aamarId}?q=${q}`,
      providesTags: ["Category"],
    }),
    AllSubCategory: builder.query<Category, any>({
      query: ({ aamarId, q }) => `/category/all/sub/${aamarId}?q=${q}`,
      providesTags: ["Category"],
    }),

    categoryCount: builder.query<Category[], any>({
      query: ({ aamarId }) => `/category/count/${aamarId}`,
      providesTags: ["Category"],
    }),
    addCategory: builder.mutation<any, any>({
      query: (Category) => ({
        url: "/category",
        method: "POST",
        body: Category,
      }),
      invalidatesTags: ["Category"],
    }),
    addImportCategory: builder.mutation<{}, Category>({
      query: (category) => ({
        url: "/category/import",
        method: "POST",
        body: category,
      }),
      invalidatesTags: ["Category"],
    }),
    updateCategory: builder.mutation<Category[], any>({
      query: ({ _id, ...rest }) => ({
        url: `/category/${_id}`,
        method: "PUT",
        body: rest,
      }),
      invalidatesTags: ["Category"],
    }),
    uploadCategoryPhoto: builder.mutation<any, any>({
      query: ({ _id, ...rest }) => ({
        url: `/category/photo/${_id}`,
        method: "POST",
        headers: {
          "content-type": "multipart/form-data",
        },
        body: rest,
      }),
      invalidatesTags: ["Category"],
    }),
    deleteCategory: builder.mutation<void, string>({
      query: (id) => ({
        url: `/category/${id}`,
        method: "DELETE",
      }),
      invalidatesTags: ["Category"],
    }),
  }),
});

export const {
  useCategoriesQuery,
  useCategoriesExportQuery,
  useCategoryQuery,
  useMasterCategoryQuery,
  useMasterCategoryListQuery,
  useCategoryListQuery,
  useCategoryImportListQuery,
  useAddCategoryMutation,
  useAddImportCategoryMutation,
  useUpdateCategoryMutation,
  useUploadCategoryPhotoMutation,
  useDeleteCategoryMutation,
  useAllCategoryQuery,
  useAllSubCategoryQuery,
  useCategoryCountQuery,
} = CategoryApi;

export default CategoryApi;
